/* eslint-disable */
import r1 from './r1.js'

var r = function () {
  function r() {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, r),
      this.update = this.update.bind(this),
      this.binders = [],
      this.raf = null,
      this.now = Date.now(),
      this.time = this.now,
      this.deltaTime = 0
  }
  return r1(r, [{
    key: "update",
    value: function () {
      this.now = Date.now(),
        this.deltaTime = this.now - this.time,
        this.time = this.now;
      for (var e = 0; e < this.binders.length; e++)
        this.binders[e].fn(this.deltaTime);
      this.raf = window.requestAnimationFrame(this.update)
    }
  }], [{
    key: "start",
    value: function () {
      r.INSTANCE || (r.INSTANCE = new r),
        r.INSTANCE.update(),
        window.raf = function () {
          r.debug()
        }
    }
  }, {
    key: "stop",
    value: function () {
      window.cancelAnimationFrame(r.INSTANCE.raf)
    }
  }, {
    key: "bind",
    value: function (e, t) {
      var n = r.INSTANCE;
      if ("string" == typeof e && "function" == typeof t) {
        for (var i = 0; i < n.binders.length; i++) {
          if (n.binders[i].id === e)
            return
        }
        r.INSTANCE.binders.push({
          id: e,
          fn: t
        })
      }
    }
  }, {
    key: "unbind",
    value: function (e) {
      for (var t = r.INSTANCE, n = 0; n < t.binders.length; n++)
        if (t.binders[n].id === e) {
          t.binders.splice(n, 1);
          break
        }
    }
  }, {
    key: "debug",
    value: function () { }
  }]),
    r
}();
var t = { default: r }

export default t
